export function setCanonical(path) {
  const link = document.getElementById('canonical-link');
  if (link) {
    link.setAttribute('href', `https://affordscope.com${path}`);
  }
}

export function setPageTitle(title) {
  document.title = `${title} | AffordScope`;
}

export function setMetaDescription(description) {
  let meta = document.querySelector('meta[name="description"]');
  if (meta) {
    meta.setAttribute('content', description);
  }
}

export function generateFAQSchema(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
}

export function generateBreadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": item.name,
      "item": item.url ? `https://affordscope.com${item.url}` : undefined
    }))
  };
}

export function generateWebsiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "AffordScope",
    "url": "https://affordscope.com",
    "description": "Compare cost of living and salary affordability across US cities",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://affordscope.com/cost-of-living-in-{search_term}",
      "query-input": "required name=search_term"
    }
  };
}

export function generateOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "AffordScope",
    "url": "https://affordscope.com",
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "support@lifeownit.com",
      "contactType": "customer service"
    }
  };
}

export function generateServiceSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Financial Planning Tool",
    "name": "AffordScope Salary & Cost of Living Calculator",
    "description": "Free interactive tools to calculate salary after taxes, compare cost of living across US cities, and determine housing affordability. Covers 1,900+ pages across 24+ major US cities.",
    "provider": {
      "@type": "Organization",
      "name": "AffordScope",
      "url": "https://affordscope.com"
    },
    "areaServed": {
      "@type": "Country",
      "name": "United States"
    },
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD",
      "description": "Free salary calculator, city comparison, budget planner, and AI-powered city search"
    }
  };
}

export function generateHowToSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": "How to Check If You Can Afford to Live in a US City",
    "description": "Use AffordScope's free calculator to find out if your salary is enough to live comfortably in any US city.",
    "step": [
      {
        "@type": "HowToStep",
        "position": 1,
        "name": "Enter Your Annual Salary",
        "text": "Type your gross annual salary (before taxes) into the calculator. For example, $80,000."
      },
      {
        "@type": "HowToStep",
        "position": 2,
        "name": "Select a City",
        "text": "Choose from 24+ major US cities including New York, Los Angeles, Houston, Chicago, Miami, and more."
      },
      {
        "@type": "HowToStep",
        "position": 3,
        "name": "Get Your Affordability Verdict",
        "text": "Instantly see your monthly take-home pay after federal and state taxes, rent costs, grocery expenses, transportation, utilities, healthcare, and whether your salary is Comfortable, Tight, or Not Affordable for that city."
      }
    ],
    "totalTime": "PT30S"
  };
}

export function generateSpeakableSchema(pagePath, headlines, summaries) {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": headlines[0] || "AffordScope",
    "url": `https://affordscope.com${pagePath}`,
    "speakable": {
      "@type": "SpeakableSpecification",
      "cssSelector": [".speakable-headline", ".speakable-summary"]
    }
  };
}

export function generateArticleSchema(title, slug, datePublished, description) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": title,
    "url": `https://affordscope.com/blog/${slug}`,
    "datePublished": datePublished,
    "dateModified": datePublished,
    "description": description,
    "author": {
      "@type": "Organization",
      "name": "AffordScope",
      "url": "https://affordscope.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "AffordScope",
      "url": "https://affordscope.com"
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://affordscope.com/blog/${slug}`
    },
    "speakable": {
      "@type": "SpeakableSpecification",
      "cssSelector": [".speakable-headline", ".speakable-summary"]
    }
  };
}
